export const items = (state) => state.items
export const itemDiscount = (state) => state.item_discount
